import makeStyles from '@mui/styles/makeStyles';

export const useStyles = makeStyles(() => ({
    label: {
        fontSize: '12px'
    }
}));
